<cosmos-section
  sectionTitle="Email Invites"
  class="cosmos-cluster-details-modal__section"
>
  <cosmos-table
    [columns]="_columns"
    [dataSource]="_dataSource"
    [isFilterable]="false"
    [isPaginable]="false"
  ></cosmos-table>
  <button
    addButton
    (click)="openSendEmailDialog()"
    class="cosmos-cluster-details-modal__button"
  >
    Invite Collaborator
  </button>
</cosmos-section>

<ng-template #actions let-data="row">
  <button
    (click)="removeInvitation(data)"
    class="cosmos-cluster-invites__button"
  >
    Remove
  </button>
</ng-template>
